<template>
  <v-row no-gutters>
    <v-container fluid>
      <v-row class="mt-7">
        <Header :value="'Форматы консультаций:'"/>
      </v-row>

      <v-row>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
          <ProblemCard :value="{
            title: 'Очная консультация',
            text: 'Очно в уютном кабинете в центре Москвы\n'+
'                    (м. Библиотека им.Ленина/Арбатская).\n'+
'                    4000 руб./55 мин. Карту и подробное описание,\n'+
'                    как добраться Вы можете найти в разделе Контакты'
          }" :index="99"/>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
          <ProblemCard
            :value="{
            title: 'Онлайн-консультация:',
            text: 'Встреча в онлайн формате (Яндекс-телемост) в любом удобном для Вас тихом месте, где Вас не будут\n'+
'                    беспокоить. 4000 руб./55 минут.'
          }"
          :index="100"/>
        </v-col>
      </v-row>
      <v-row class="title font-weight-light text-center">
        <v-col cols="12">
          Для записи на консультацию заполните, пожалуйста, форму.
        </v-col>
        <v-col cols="12">
          Я обязательно свяжусь с Вами для обсуждения
          деталей и дальнейших действий.
        </v-col>
        <v-col cols="12">
          Если у Вас остались вопросы -
          <router-link to="/contact">
            пишите
          </router-link>
          , я постараюсь на них ответить!
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row class="title font-weight-light">
        <v-col class="text-center">
          <v-form class="formRecord"
                  @submit.prevent="sendData"
                  ref="form"
                  v-model="valid"
                  :lazy-validation="lazy"
          >
            <v-text-field
              outlined
              v-model="clientInfo.fio"
              :counter="30"
              :rules="nameRules"
              label="Имя*"
              required
            ></v-text-field>

            <v-text-field
              outlined
              v-model="clientInfo.email"
              :rules="emailRules"
              label="E-mail*"
              required
            ></v-text-field>

            <v-text-field
              outlined
              v-model="clientInfo.phone"
              :rules="phoneRules"
              label="Телефон*"
              required
            ></v-text-field>

            <v-select
              outlined
              v-model="clientInfo.consultation_format"
              :items="items"
              label="Формат консультации"
            ></v-select>

            <v-text-field
              outlined
              v-model="clientInfo.way_communication"
              :rules="communicateRules"
              :counter="50"
              label="Предпочтительный способ связи"
            ></v-text-field>

            <v-textarea
              outlined
              v-model="clientInfo.description_of_problem"
              auto-grow
              :counter="counter ? counter : false"
              label="Опишите свою проблему"
            ></v-textarea>

            <v-checkbox
              outlined
              v-model="checkbox"
              :rules="[v => !!v || 'Согласие обязательно']"
              label="Я даю согласие на обработку персональных данных и ознакомлен(а) с Политикой конфиденциальности"
              required
            ></v-checkbox>

            <v-btn type="submit"
                   :disabled="!valid"
                   color="success"
                   @click="validate"
            >
              Записаться
            </v-btn>

          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import Header from "@/components/Header";
import ProblemCard from "@/components/ProblemCard";

export default {
  name: "Record",
  components: {ProblemCard, Header},
  data: () => ({
    valid: true,
    lazy: true,
    nameRules: [
      v => !!v || 'Обязательное поле',
      v => (v && v.length <= 30) || 'Слишком длинное имя',
    ],
    emailRules: [
      v => !!v || 'По этому адресу вы получите подтверждение о заявке',
      v => /.+@.+\..+/.test(v) || 'Введите верный адрес',
    ],
    phoneRules: [
      v => !!v || 'По этому номеру проходит подтверждение о заявке',
      v => /[0-9]{10,}/.test(v) || 'Введите верный телефон',
    ],
    items: [
      'Очно',
      'Online',
    ],
    communicateRules: [
      v => (v.length <= 50) || 'Слишком длинное сообщение',
    ],
    problemRules: [
      v => !!v || 'Обязательное поле',
      v => (v && v.length <= 2000) || 'Слишком длинное сообщение',
    ],
    counter: 2000,
    clientInfo: {
      fio: '',
      email: '',
      phone: '',
      consultation_format: null,
      way_communication: '',
      description_of_problem: '',

    },
    checkbox: false,
  }),
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    // todo переписать через аксиос
    async sendData() {
      await fetch('https://psychology-help.ru/api/contact/', {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(this.clientInfo)
        }
      ).then(
        (response => {
            if (response.ok) {
              this.$router.push({path: '/successful_entry'})
              this.cleanState();
            } else if (response.status === 406) {
              alert('Вы уже подали заявку');
            } else {
              alert("server error " + response.status + ", try later " + JSON.stringify(this.$store.state.sendForm.inputDataOfUser));
            }
          }
        )
      ).catch(err => console.log(err));
    }
  },
}
</script>

<style scoped>

.formRecord {
  max-width: 500px;
  margin: auto;
  padding: 1em;
}

.card1 {
  background-image: url('../../public/pictures/record/online.jpg');
  background-position: center center;
}

.card2 {
  background-image: url('../../public/pictures/record/offline.jpg');
  background-position: center center;
}

</style>
